export const arrayToQueryString = (key: string, array: (string | number)[]) => {
  return array.length > 0
    ? array.map((item) => `${key}=${encodeURIComponent(item)}`).join('&')
    : '';
};
